export default function notificationBrowser({ onClick, body, icon, title }) {
  if (Notification.permission === "granted" && localStorage.getItem("user")) {
    const notification = new Notification(title, {
      body,
      icon,
    });

    notification.onclick = onClick;
  }
}
